import React from "react";

import TopNavbar from "../topNavbar/TopNavbar";
import PageHeader from "../../pages/pageHeader/PageHeader";
import DsearSummary from "../PageApps/DsearSummary";
import Div100vh from "react-div-100vh/lib/Div100vh";
import Select from "react-select";
import { useSelector } from "react-redux";
import ProjectFinder from "../projectFinder/ProjectFinder";
import { useEffect, useState } from "react";
import axios from "axios";
import { HOST_URL } from "../../helpers/constants/Constants";
import makeAnimated from "react-select/animated";
import { getSelectedProject } from "../../helpers/actions/Action";
import store from "../../helpers/store/Store";

const DSEARRegister = (props) => {
  const [dsears, setDsears] = useState();
  const [dsearFilter, setDsearFilter] = useState({});
  const [selectedDsear, setSelectedDsear] = useState(null);
  const [editDsear, setEditDsear] = useState(false);
  const animatedComponents = makeAnimated();

  // Reducers ----------------------------------------------
  const selectedProject = useSelector(
    (state) => state.getSelectedProjectReducer.data
  );
  const projectData = useSelector(
    (state) => state.requestProjectsDataReducer.data
  );
  const user = useSelector((state) => state.requestUserDataReducer.data);
  const [seniorDesignersDropDownData, setSeniorDesignersDropDownData] =
    useState([
      // {
      //   value: `robert.field@mwhtreatment.com`,
      //   label: `Robert Field - robert.field@mwhtreatment.com`,
      // },
      // {
      //   value: `jHollings@anglianwater.co.uk`,
      //   label: `Jody Hollingsworth - jHollings@anglianwater.co.uk`,
      // },
      {
        value: `pcurtis@anglianwater.co.uk`,
        label: `Paul Curtis - pcurtis@anglianwater.co.uk`,
      },
      {
        value: `jglenister@anglianwater.co.uk`,
        label: `James Glenister - jglenister@anglianwater.co.uk`,
      },
      {
        value: `dalderson@anglianwater.co.uk`,
        label: `Dan Alderson - dalderson@anglianwater.co.uk`,
      },
    ]);

  const dsearTableChangeHandler = (e, att, zone) => {
    let temp;

    console.log("DSEAR", submissionForm.dsearZone);
    console.log("options", zone);

    temp = {
      ...submissionForm,
      [att]: submissionForm.dsearZone.map((input) => {
        console.log("input zone", input.zone);
        if (input.zone === zone) {
          return { zone: input.zone, rating: e.target.value, other: "" };
        } else {
          return { zone: input.zone, rating: input.rating, other: "" };
        }
      }),
    };
    setSubmissionForm(temp);
  };

  const [leadEngineerDropDownData, setLeadEngineerDropDownData] = useState([
    // {
    //   value: `robert.field@mwhtreatment.com`,
    //   label: `Robert Field - robert.field@mwhtreatment.com`,
    // },
    // {
    //   value: `jHollings@anglianwater.co.uk`,
    //   label: `Jody Hollingsworth - jHollings@anglianwater.co.uk`,
    // },
    {
      value: `nkingsley@anglianwater.co.uk`,
      label: `Nigel Kingsley - nkingsley@anglianwater.co.uk`,
    },
    {
      value: `epasse@anglianwater.co.uk`,
      label: `Emma Passe - epasse@anglianwater.co.uk`,
    },
    {
      value: `pmorgancox3@anglianwater.co.uk`,
      label: `Peter Morgan-Cox - pmorgancox3@anglianwater.co.uk`,
    },

    {
      value: `tsmith3@anglianwater.co.uk`,
      label: `Tim Smith - tsmith3@anglianwater.co.uk`,
    },
    {
      value: `pmclaughlan@anglianwater.co.uk`,
      label: `Paul McLaughan - pmclaughlan@anglianwater.co.uk`,
    },
    {
      value: `pbibby@anglianwater.co.uk`,
      label: `Peter Bibby - pbibby@anglianwater.co.uk`,
    },
    {
      value: `arazzaque@anglianwater.co.uk`,
      label: `Abdur Razzaque- arazzaque@anglianwater.co.uk`,
    },
    {
      value: `jbird2@anglianwater.co.uk`,
      label: `Jon Bird - jbird2@anglianwater.co.uk`,
    },
    {
      value: `lnicholson2@anglianwater.co.uk`,
      label: `Luke Nicholson- lnicholson2@anglianwater.co.uk`,
    },
    {
      value: `cmeloni3@anglianwater.co.uk`,
      label: `Chris Meloni- cmeloni3@anglianwater.co.uk`,
    },
    {
      value: `sharrison2@anglianwater.co.uk`,
      label: `Slavka Harrison - sharrison2@anglianwater.co.uk`,
    },
    {
      value: `mgraham2@anglianwater.co.uk`,
      label: `Mungo Graham - mgraham2@anglianwater.co.uk`,
    },
    {
      value: `pstott2@anglianwater.co.uk`,
      label: `Peter Stott - pstott2@anglianwater.co.uk`,
    },
    {
      value: `lpotts@anglianwater.co.uk`,
      label: `Lee Potts - lpotts@anglianwater.co.uk`,
    },
    {
      value: `swilliams5@anglianwater.co.uk`,
      label: `Sarah Williams - swilliams5@anglianwater.co.uk`,
    },
    {
      value: `adolea@anglianwater.co.uk`,
      label: `Alex Dolea - adolea@anglianwater.co.uk`,
    },
    {
      value: `nmcnab@anglianwater.co.uk`,
      label: `Neil McNab - nmcnab@anglianwater.co.uk`,
    },
    {
      value: `acaballero@anglianwater.co.uk`,
      label: `Alvaro Jimenez Caballeroa - acaballero@anglianwater.co.uk`,
    },
    {
      value: `cmuruais@anglianwater.co.uk`,
      label: `Cristina Muruais - cmuruais@anglianwater.co.uk`,
    },
    {
      value: `rhampton3@anglianwater.co.uk`,
      label: `Ross Hampton (ST) - rhampton3@anglianwater.co.uk`,
    },
    {
      value: `sJackson@anglianwater.co.uk`,
      label: `Stephen Jackson - sJackson@anglianwater.co.uk`,
    },
    // {
    //   value: `pmorgancox3@anglianwater.co.uk`,
    //   label: `Nigel Darius - pmorgancox3@anglianwater.co.uk`,
    // },
    ,
  ]);

  const [practitionerDropDownData, setPractitionerDropDownData] = useState([
    // {
    //   value: `robert.field@mwhtreatment.com`,
    //   label: `Robert Field - robert.field@mwhtreatment.com`,
    // },
    // {
    //   value: `jHollings@anglianwater.co.uk`,
    //   label: `Jody Hollingsworth - jHollings@anglianwater.co.uk`,
    // },
    {
      value: `pcurtis@anglianwater.co.uk`,
      label: `Paul Curtis - pcurtis@anglianwater.co.uk`,
    },
    {
      value: `pstott2@anglianwater.co.uk`,
      label: `Peter Stott - pstott2@anglianwater.co.uk`,
    },
    {
      value: `mworthington@anglianwater.co.uk`,
      label: `Michael Worthington - mworthington@anglianwater.co.uk`,
    },
    {
      value: `dcrooks@anglianwater.co.uk`,
      label: `Darren Crooks - dcrooks@anglianwater.co.uk`,
    },
    {
      value: `lpotts@anglianwater.co.uk`,
      label: `Lee Potts - lpotts@anglianwater.co.uk`,
    },
    {
      value: `mgraham2@anglianwater.co.uk`,
      label: `Mungo Graham - mgraham2@anglianwater.co.uk`,
    },
    {
      value: `maria.grigorova@mwhtreatment.com`,
      label: `Maria Grigorova - maria.grigorova@mwhtreatment.com`,
    },
  ]);

  const [ragStatus, setRagStatus] = useState("RED");
  const [submissionForm, setSubmissionForm] = useState({
    projectName: selectedProject.text,
    date: "",
    tm: "",
    tmRag: "RED",
    sdm: "",
    flidsRisk: "",
    flidsOutcome: "",
    dsearZone: [],
    dsearIden: "NO",
    dsearImp: "NO",
    dsearSpec: "NO",
    dsearApp: "NO",
    practionerFlag: "NO",
  });

  useEffect(() => {
    // Dsear ----------------------------------------------
    loadDsear();
  }, []);

  const loadDsear = () => {
    axios({
      method: "Get",
      url: HOST_URL + "/api/dsear",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      withCredentials: true,
    })
      .then((response) => {
        setDsears(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (selectedProject != null && selectedProject != "") {
      selectViewDsear();
    }
  }, [selectedProject]);

  const handleFilterDataUpdate = (e, context, type, select) => {
    var filter = "";
    if (select) {
      if (e != null) {
        var tempData = [];
        e.forEach((user) => {
          tempData.push(user.value);
        });
        filter = tempData;
      }
    } else {
      filter = e.target.value;
    }
    switch (context) {
      case "dsearFilter":
        var temp = {
          ...dsearFilter,
          [type]: filter,
        };
        setDsearFilter(temp);
        console.log("filters - ", temp);
        break;
    }
  };

  const selectViewDsear = () => {
    let formData = new FormData();
    formData.append(
      "formData",
      JSON.stringify({ projectName: selectedProject.text })
    );
    axios({
      method: "post",
      url: HOST_URL + `/api/dsear/get`,
      data: formData,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
      .then((response) => {
        if (response.data != null && response.data != "") {
          setSelectedDsear(response.data);
          // if (response.data.tmRag != "RED") {
          //   response.data.dsearIden = "YES";
          //   response.data.dsearImp = "YES";
          //   response.data.dsearSpec = "YES";
          //   response.data.dsearApp = "YES";
          // } else {
          //   response.data.dsearIden = "NO";
          //   response.data.dsearImp = "NO";
          //   response.data.dsearSpec = "NO";
          //   response.data.dsearApp = "NO";
          // }
          if (response.data.practitioner != null) {
            response.data.practionerFlag = "YES";
          } else {
            response.data.practionerFlag = "NO";
          }
          setSubmissionForm(response.data);
          console.log("submissionForm", response.data);
        } else {
          setSubmissionForm({
            projectName: selectedProject.text,
            date: "",
            tm: "",
            tmRag: "RED",
            sdm: "",
            flidsRisk: "",
            flidsOutcome: "",
            dsearZone: [],
            dsearIden: "NO",
            dsearImp: "NO",
            dsearSpec: "NO",
            dsearApp: "NO",
            practionerFlag: "NO",
          });
          setSelectedDsear(null);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const approveDsear = () => {
    let formData = new FormData();
    formData.append(
      "formData",
      JSON.stringify({
        dsearId: selectedDsear.id,
        email: user.email,
      })
    );
    axios({
      method: "post",
      url: HOST_URL + `/api/dsear/approve`,
      data: formData,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
      .then((response) => {
        console.log("response", response);
        selectViewDsear();
        loadDsear();
        //getData(); reload
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const clearSelectedProject = (e) => {
    store.dispatch(getSelectedProject(""));
    setEditDsear(false);
  };

  const setSelectedProject = (selectedProject) => {
    var project = projectData.find((o) => o.text == selectedProject);
    console.log(project);
    store.dispatch(getSelectedProject(project));
  };

  const filterDsear = (dsear, filter) => {
    if (
      (filter.projectName == null ||
        filter.projectName == "" ||
        dsear.projectName
          ?.toLowerCase()
          .includes(filter.projectName.toLowerCase())) &&
      (filter.date == null ||
        filter.date == "" ||
        dsear.date?.toLowerCase().includes(filter.date.toLowerCase())) &&
      (filter.tm == null ||
        filter.tm == "" ||
        dsear.tm?.toLowerCase().includes(filter.tm.toLowerCase())) &&
      (filter.sdms == null ||
        filter.sdms == "" ||
        filter.sdms.some((sf) => dsear.sdms.some((s) => s.email == sf))) &&
      (filter.flidsRisk == null ||
        filter.flidsRisk == "" ||
        filter.flidsRisk?.some((o) =>
          o.toLowerCase().includes(dsear.flidsRisk?.toLowerCase())
        )) &&
      (filter.flidsOutcome == null ||
        filter.flidsOutcome == "" ||
        filter.flidsOutcome?.some((o) =>
          o.toLowerCase().includes(dsear.flidsOutcome?.toLowerCase())
        )) &&
      (filter.dsearZone == null ||
        filter.dsearZone == "" ||
        filter.dsearZone?.every((dsf) =>
          dsear.dsearZone
            .map((d) => `${d.zone}`)
            .some((ds) => ds.toLowerCase().includes(dsf.toLowerCase()))
        )) &&
      (filter.dsearRating == null ||
        filter.dsearRating == "" ||
        filter.dsearRating?.every((dsf) =>
          dsear.dsearZone
            .map((d) => `${d.rating}`)
            .some((ds) => ds.toLowerCase().includes(dsf.toLowerCase()))
        )) &&
      (filter.tmRag == null ||
        filter.tmRag == "" ||
        filter.tmRag?.some((o) =>
          o.toLowerCase().includes(dsear.tmRag?.toLowerCase())
        ))
    ) {
      return dsear;
    }
  };

  //---------------------Dsear
  const changeHandler = (e, att, zone) => {
    var value = e.target.value;

    let temp;

    temp = { ...submissionForm, [att]: value };
    if (
      temp.dsearIden == "YES" &&
      temp.dsearImp == "YES" &&
      temp.dsearSpec == "YES" &&
      temp.dsearApp == "YES"
    ) {
      temp.tmRag = "AMBER";
    } else {
      temp.tmRag = "RED";
    }
    temp.projectName = selectedProject.text;
    setRagStatus(temp.tmRag);
    setSubmissionForm(temp);
  };

  const dsearChangeHandler = (e, att) => {
    let temp;
    //Current
    debugger;

    var tempCurrent = submissionForm.dsearZone.filter((d) =>
      e
        .map((o) => {
          return o.value;
        })
        .includes(d.zone)
    );

    e.forEach((v) => {
      //add missing
      if (tempCurrent.find((o) => o.zone == v.value) == null) {
        tempCurrent.push({ zone: v.value, rating: "", other: "" });
      }
    });

    temp = {
      ...submissionForm,
      [att]: tempCurrent,
    };
    setSubmissionForm(temp);
  };
  const dsearZones = [
    { value: "TPS", label: "TPS" },
    { value: "Inlet Works", label: "Inlet Works" },
    { value: "Storm Tanks", label: "Storm Tanks" },
    { value: "PST", label: "PST" },
    { value: "Sludge Tanks", label: "Sludge Tanks" },
    { value: "Diesel Storage", label: "Diesel Storage" },
    { value: "Chemical Storage", label: "Chemical Storage" },
    { value: "OSEC", label: "OSEC" },
    { value: "Septic Tanks", label: "Septic Tanks" },
    { value: "Sludge Handling", label: "Sludge Handling" },
    { value: "Other", label: "Other" },
  ];

  const seniorInputHandler = (e) => {
    var tempData = [];
    if (e) {
      e.forEach((user) => {
        tempData.push({ email: user.value });
      });
    }
    let temp = { ...submissionForm, ["sdms"]: tempData };
    setSubmissionForm(temp);
  };

  const leadEngineerInputHandler = (e) => {
    let temp = { ...submissionForm, ["leadEngineer"]: e.value };
    setSubmissionForm(temp);
  };

  const practitionerInputHandler = (e) => {
    let temp = { ...submissionForm, ["practitioner"]: e.value };
    setSubmissionForm(temp);
  };

  const save = async () => {
    let formData = new FormData();
    formData.append("formData", JSON.stringify({ ...submissionForm }));
    axios({
      method: "post",
      url: HOST_URL + `/api/dsear/saveOrCreate`,
      data: formData,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
      .then((response) => {
        debugger;
        setEditDsear(false);
        selectViewDsear();
        loadDsear();
      })
      .catch((error) => {
        debugger;
        console.log(error);
      });
  };

  return (
    <div style={{ overflowY: "auto" }}>
      <Div100vh>
        <TopNavbar />
        <PageHeader src="/water-bg.jpeg" alt="water-bg" />
        <DsearSummary />
        <br />
        <br />
        <br />
        <br />

        <div className="d-flex justify-content-center">
          <div className="col-4">
            <ProjectFinder />
          </div>
          {selectedProject != null && selectedProject != "" && (
            <button
              type="button"
              className="btn btn-primary mr-2"
              onClick={() => clearSelectedProject()}>
              Back
            </button>
          )}
          {selectedProject != null &&
            selectedProject != "" &&
            submissionForm.id != null && (
              <button
                type="button"
                className="btn btn-info mr-2"
                onClick={() => setEditDsear(!editDsear)}>
                {editDsear ? "Cancel" : "Edit"}
              </button>
            )}
        </div>
        {/* Display Table */}
        <div className="p-4">
          {(selectedProject == null || selectedProject == "") && (
            <table className="table">
              <thead>
                <tr>
                  <th
                    scope=""
                    style={{ backgroundColor: "White", border: "none" }}></th>
                  <th
                    scope="col"
                    style={{ backgroundColor: "White", border: "none" }}>
                    <input
                      className="form-control"
                      type="text"
                      id="filterProjectName"
                      placeholder="Project Name"
                      onChange={(e) =>
                        handleFilterDataUpdate(
                          e,
                          "dsearFilter",
                          "projectName",
                          false
                        )
                      }
                    />
                  </th>
                  <th
                    scope="col"
                    style={{ backgroundColor: "White", border: "none" }}>
                    <input
                      className="form-control"
                      type="date"
                      id="filterDate"
                      placeholder="Date"
                      onChange={(e) =>
                        handleFilterDataUpdate(e, "dsearFilter", "date", false)
                      }
                    />
                  </th>
                  <th
                    scope="col"
                    style={{ backgroundColor: "White", border: "none" }}>
                    <input
                      className="form-control"
                      type="text"
                      id="filterTechnicalManager"
                      placeholder="Technical Manager"
                      onChange={(e) =>
                        handleFilterDataUpdate(e, "dsearFilter", "tm", false)
                      }
                    />
                  </th>
                  <th
                    scope="col"
                    style={{
                      backgroundColor: "White",
                      border: "none",
                      width: "200px",
                    }}>
                    <Select
                      closeMenuOnSelect={false}
                      components={animatedComponents}
                      placeholder="Senior Design Managers"
                      isMulti
                      options={dsears
                        ?.map((o) => o.sdms.map((o) => o.email))
                        .flat()
                        .filter(
                          (value, index, array) =>
                            array.indexOf(value) === index
                        )
                        .map((o) => ({ value: o, label: o }))}
                      onChange={(e) =>
                        handleFilterDataUpdate(e, "dsearFilter", "sdms", true)
                      }
                    />
                  </th>
                  <th
                    className="col"
                    scope="col"
                    style={{
                      backgroundColor: "White",
                      border: "none",
                      width: "200px",
                    }}>
                    <Select
                      closeMenuOnSelect={false}
                      components={animatedComponents}
                      placeholder="FLIDS Risk"
                      isMulti
                      options={dsears
                        ?.map((o) => o.flidsRisk)
                        .filter(
                          (value, index, array) =>
                            array.indexOf(value) === index
                        )
                        .map((o) => ({ value: o, label: o }))}
                      onChange={(e) =>
                        handleFilterDataUpdate(
                          e,
                          "dsearFilter",
                          "flidsRisk",
                          true
                        )
                      }
                    />
                  </th>
                  <th
                    scope="col"
                    style={{
                      backgroundColor: "White",
                      border: "none",
                      width: "200px",
                    }}>
                    <Select
                      closeMenuOnSelect={false}
                      components={animatedComponents}
                      placeholder="FLIDS Outcome"
                      isMulti
                      options={dsears
                        ?.map((o) => o.flidsOutcome)
                        .filter(
                          (value, index, array) =>
                            array.indexOf(value) === index
                        )
                        .map((o) => ({ value: o, label: o }))}
                      onChange={(e) =>
                        handleFilterDataUpdate(
                          e,
                          "dsearFilter",
                          "flidsOutcome",
                          true
                        )
                      }
                    />
                  </th>
                  <th
                    className="col"
                    scope="col"
                    style={{
                      backgroundColor: "White",
                      border: "none",
                      width: "200px",
                    }}>
                    {/* <input
                      className="form-control"
                      type="text"
                      id="filterDsearZones"
                      placeholder="Dsear Zones"
                      onChange={(e) =>
                        handleFilterDataUpdate(
                          e,
                          "dsearFilter",
                          "dsearZone",
                          false
                        )
                      }
                    /> */}
                    {/* .map((o) => o.dsearZone.map(d=>`${d.zone} - ${d.rating}`)) */}
                    <Select
                      closeMenuOnSelect={false}
                      components={animatedComponents}
                      placeholder="DSEAR Zones"
                      isMulti
                      options={dsears
                        ?.map((o) =>
                          // o.dsearZone.map((d) => `${d.zone} ${d.rating}`)
                          o.dsearZone.map((d) => `${d.zone}`)
                        )
                        .flat()
                        .filter(
                          (value, index, array) =>
                            array.indexOf(value) === index
                        )
                        .map((o) => ({ value: o, label: o }))
                        .sort((a, b) => a.label.localeCompare(b.label))}
                      onChange={(e) =>
                        handleFilterDataUpdate(
                          e,
                          "dsearFilter",
                          "dsearZone",
                          true
                        )
                      }
                    />
                  </th>
                  <th
                    className="col"
                    scope="col"
                    style={{
                      backgroundColor: "White",
                      border: "none",
                      width: "200px",
                    }}>
                    {/* <input
                      className="form-control"
                      type="text"
                      id="filterDsearZones"
                      placeholder="Dsear Zones"
                      onChange={(e) =>
                        handleFilterDataUpdate(
                          e,
                          "dsearFilter",
                          "dsearZone",
                          false
                        )
                      }
                    /> */}
                    {/* .map((o) => o.dsearZone.map(d=>`${d.zone} - ${d.rating}`)) */}
                    <Select
                      closeMenuOnSelect={false}
                      components={animatedComponents}
                      placeholder="DSEAR Ratings"
                      isMulti
                      options={dsears
                        ?.map((o) =>
                          // o.dsearZone.map((d) => `${d.zone} ${d.rating}`)
                          o.dsearZone.map((d) => `${d.rating}`)
                        )
                        .flat()
                        .filter(
                          (value, index, array) =>
                            array.indexOf(value) === index
                        )
                        .map((o) => ({ value: o, label: o }))
                        .sort((a, b) => a.label.localeCompare(b.label))}
                      onChange={(e) =>
                        handleFilterDataUpdate(
                          e,
                          "dsearFilter",
                          "dsearRating",
                          true
                        )
                      }
                    />
                  </th>
                  <th
                    className="col"
                    scope="col"
                    style={{
                      backgroundColor: "White",
                      border: "none",
                      width: "200px",
                    }}>
                    <Select
                      closeMenuOnSelect={false}
                      components={animatedComponents}
                      placeholder="Tm RAG"
                      isMulti
                      options={dsears
                        ?.map((o) => o.tmRag)
                        .filter(
                          (value, index, array) =>
                            array.indexOf(value) === index
                        )
                        .map((o) => ({ value: o, label: o }))}
                      onChange={(e) =>
                        handleFilterDataUpdate(e, "dsearFilter", "tmRag", true)
                      }
                    />
                  </th>
                </tr>
                <tr>
                  <th scope="">Actions</th>
                  <th scope="col">Project</th>
                  <th scope="col">Date</th>
                  <th scope="col">Technical Manager</th>
                  <th scope="col">Senior Design Managers</th>
                  <th scope="col">FLIDS Risk</th>
                  <th scope="col">FLIDS Outcome</th>
                  <th scope="col">DSEAR Zones</th>
                  <th scope="col">DSEAR Ratings</th>
                  <th scope="col">TM RAG</th>
                </tr>
              </thead>
              <tbody>
                {/* ?.map((o) => o.dsearZone)
                        .map((o) => `${o.zone} - ${o.rating}`)
                        .filter(
                          (value, index, array) =>
                            array.indexOf(value) === index
                        )
                        .map((o) => ({ value: o, label: o }) */}
                {console.log(
                  "dsear",
                  dsears?.map((o) => o.dsearZone.map((d) => `${d.zone}`))
                )}
                {dsears?.map((dsear, i) => {
                  console.log(dsear);
                  if (filterDsear(dsear, dsearFilter)) {
                    return (
                      <tr>
                        <td>
                          <div className="d-flex flex-row">
                            {projectData.some(
                              (o) => o.text == dsear.projectName
                            ) && (
                              <button
                                title="View"
                                value={dsear.id}
                                type="button"
                                className="btn btn-sm btn-primary ml-1 p-0"
                                onClick={(e) =>
                                  setSelectedProject(dsear.projectName)
                                }>
                                <span>
                                  <i className="icon-eye"></i>
                                </span>
                              </button>
                            )}
                            {!projectData.some(
                              (o) => o.text == dsear.projectName
                            ) && <p>Access Required</p>}
                          </div>
                        </td>
                        <td>
                          <span>{dsear.projectName}</span>
                        </td>
                        <td>{dsear.date}</td>
                        <td>{dsear.tm}</td>
                        <td>{dsear.sdms.map((o) => o.email).join(", ")}</td>
                        <td>{dsear.flidsRisk}</td>
                        <td>{dsear.flidsOutcome}</td>
                        <td>
                          {dsear.dsearZone.map((z) => {
                            return <p>{z.zone}</p>;
                          })}
                        </td>
                        <td>
                          {dsear.dsearZone.map((z) => {
                            return <p>{z.rating}</p>;
                          })}
                        </td>
                        <td>
                          {" "}
                          <p
                            className="rounded p-1"
                            style={{
                              fontWeight: "bold",
                              backgroundColor:
                                dsear.tmRag === "AMBER"
                                  ? "#f5b642"
                                  : dsear.tmRag === "GREEN"
                                  ? "#66f542"
                                  : "#f54242",
                            }}>
                            RAG STATUS - {dsear.tmRag}
                          </p>
                        </td>
                      </tr>
                    );
                  }
                })}
              </tbody>
            </table>
          )}
          {/* Display Dsear */}
          {selectedProject != null &&
            selectedProject != "" &&
            editDsear == false &&
            selectedDsear != null && (
              <div style={{ textAlign: "left", fontSize: 13 }}>
                <h2>General</h2>
                <div>
                  <p
                    className="rounded p-1"
                    style={{
                      fontWeight: "bold",
                      backgroundColor:
                        selectedDsear?.tmRag === "AMBER"
                          ? "#f5b642"
                          : selectedDsear?.tmRag === "GREEN"
                          ? "#66f542"
                          : "#f54242",
                    }}>
                    RAG STATUS - {selectedDsear?.tmRag}
                  </p>
                  {selectedDsear?.tmRag === "AMBER" && (
                    <p>
                      It is for the Senior Design Manager to approve once they
                      felt the questions/issues have been addressed.
                    </p>
                  )}
                  {selectedDsear?.tmRag === "RED" && (
                    <p>
                      It is for the Senior Design Manager to approve each
                      submission. This will not be possible until most of the
                      questions/issues have been addressed and can move to amber
                      status
                    </p>
                  )}
                </div>
                <label htmlFor="exampleSelect1" className="">
                  Questions:
                </label>
                <div className="row ml-4">
                  <p>
                    Are you aware of all the existing DSEAR zones impacted on
                    this site?
                  </p>
                  :<label className="ml-2">{selectedDsear.dsearIden}</label>
                </div>
                <div className="row ml-4">
                  <p>
                    Are you confident you understand the implications to design
                    for new and existing DSEAR zones?
                  </p>
                  :<label className="ml-2">{selectedDsear.dsearImp}</label>
                </div>
                <div className="row ml-4">
                  <p>
                    Have you specified the DSEAR requirements for
                    sub-contractors?
                  </p>
                  :<label className="ml-2">{selectedDsear.dsearSpec}</label>
                </div>
                <div className="row ml-4">
                  <p>
                    Are the MEICA designers approved for DSEAR/ATEX design on
                    the competency register?
                  </p>
                  :<label className="ml-2">{selectedDsear.dsearApp}</label>
                </div>

                {selectedDsear?.tmRag === "AMBER" && (
                  <table className="table table-borderless table-light table-sm">
                    <thead>
                      <tr>
                        <th scope="col">User</th>
                        <th scope="col">Status</th>
                        <th scope="col">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {console.log("sdms", selectedDsear?.sdms)}

                      {selectedDsear?.sdms?.map((sdm) => {
                        return (
                          <tr>
                            <td>{sdm.email}</td>
                            <td>{sdm.status}</td>
                            <td>
                              {console.log("email", user.email)}
                              {sdm.email.toLowerCase() ==
                                user.email.toLowerCase() &&
                              sdm.status != "Approved" ? (
                                <button
                                  type="button"
                                  className="btn btn-success"
                                  onClick={approveDsear}>
                                  Approve
                                </button>
                              ) : (
                                <></>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                )}
                <p>Date submitted - {selectedDsear.date}</p>
                <p>Technical Manager - {selectedDsear?.tm}</p>
                <p>
                  Senior Design Manager -{" "}
                  {selectedDsear.sdms
                    ?.map(
                      (sdm) =>
                        `${sdm.email}${
                          sdm.approveDate != null
                            ? `(Approved: ${sdm.approveDate})`
                            : ""
                        }`
                    )
                    .join(", ")}
                </p>
                <p>Checker/Lead Engineer - {selectedDsear?.leadEngineer}</p>
                {selectedDsear.practitioner != null && (
                  <p>Practitioner - {selectedDsear?.practitioner}</p>
                )}

                <h2 style={{ textAlign: "left" }}>FLIDS</h2>
                <table className="table">
                  <thead>
                    <tr>
                      <th>FLIDS Risk Band</th>
                      <th>FLIDS Outcome</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{selectedDsear?.flidsRisk}</td>
                      <td>{selectedDsear?.flidsOutcome}</td>
                    </tr>
                  </tbody>
                </table>
                <h2 style={{ textAlign: "left" }}>DSEAR</h2>
                <table className="table">
                  <thead>
                    <tr>
                      <th>Zone</th>
                      <th>Rating</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedDsear && selectedDsear.dsearZone != null ? (
                      selectedDsear.dsearZone.map((data) => {
                        return (
                          <tr>
                            <td>{data.zone}</td>
                            <td>{data.rating}</td>
                          </tr>
                        );
                      })
                    ) : (
                      <></>
                    )}
                  </tbody>
                </table>
              </div>
            )}
          {selectedProject != null &&
            selectedProject != "" &&
            (selectedDsear == null || editDsear == true) && (
              <div className="d-flex justify-content-center">
                <div className="col-8 text-center">
                  <br />
                  <p
                    style={{
                      fontWeight: "bold",
                    }}>
                    Please {editDsear != true ? "complete" : "edit"} the
                    following:
                    <br />
                    <small>
                      Please note that after an update all Senior Design
                      Managers approval will be reset
                    </small>
                  </p>
                  <div className="col-12 p-0">
                    <div className="form-group row">
                      <label
                        htmlFor="example-date-input"
                        className="col-4 col-form-label text-right">
                        Date of entry:
                      </label>
                      <div className="col-8 p-0">
                        <input
                          onChange={(e) => changeHandler(e, "date")}
                          className="form-control"
                          type="date"
                          id="example-date-input"
                          value={submissionForm.date}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label
                        htmlFor="example-text-input"
                        className="col-4 col-form-label text-right">
                        Technical Manager name:
                      </label>
                      <div className="col-8 p-0">
                        <input
                          className="form-control"
                          type="text"
                          autoComplete="off"
                          spellCheck="false"
                          placeholder="enter name"
                          value={submissionForm.tm}
                          id="example-text-input"
                          onChange={(e) => changeHandler(e, "tm")}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label
                        htmlFor="example-text-input"
                        className="col-4 col-form-label text-right">
                        Senior Design Manager:
                      </label>
                      <div className="col-8 p-0">
                        <Select
                          closeMenuOnSelect={false}
                          components={animatedComponents}
                          value={submissionForm?.sdms?.map((app) => {
                            return { label: app.email, value: app.email };
                          })}
                          isMulti
                          options={seniorDesignersDropDownData}
                          onChange={seniorInputHandler}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label
                        htmlFor="example-text-input"
                        className="col-4 col-form-label text-right">
                        Checker/Lead Engineer:
                      </label>
                      <div className="col-8 p-0">
                        <Select
                          closeMenuOnSelect={false}
                          components={animatedComponents}
                          value={{
                            label: submissionForm.leadEngineer,
                            value: submissionForm.leadEngineer,
                          }}
                          options={leadEngineerDropDownData}
                          onChange={leadEngineerInputHandler}
                        />
                      </div>
                    </div>
                    {submissionForm.practionerFlag == "NO" && (
                      <div className="row">
                        <div className="col-4">
                          <label></label>
                        </div>
                        <div className="col-8">
                          <small>
                            A practitioner should be engaged for all zones 0, 1
                            and 2
                          </small>
                        </div>
                      </div>
                    )}
                    <div className="form-group row">
                      <label
                        htmlFor="exampleSelect1"
                        className="col-4 col-form-label text-right">
                        Has a practitioner been engaged?
                      </label>
                      <div className="col-8 p-0">
                        <select
                          onChange={(e) => changeHandler(e, "practionerFlag")}
                          className="form-control"
                          value={submissionForm.practionerFlag}
                          id="exampleSelect1">
                          <option id="NO">NO</option>
                          <option id="YES">YES</option>
                        </select>
                      </div>
                    </div>
                    {submissionForm.practionerFlag == "YES" && (
                      <div className="form-group row">
                        <label
                          htmlFor="example-text-input"
                          className="col-4 col-form-label text-right">
                          Practitioner:
                        </label>
                        <div className="col-8 p-0">
                          <Select
                            closeMenuOnSelect={false}
                            components={animatedComponents}
                            value={{
                              label: submissionForm.practitioner,
                              value: submissionForm.practitioner,
                            }}
                            options={practitionerDropDownData}
                            onChange={practitionerInputHandler}
                          />
                        </div>
                      </div>
                    )}
                    <div className="form-group row">
                      <label
                        htmlFor="exampleSelect1"
                        className="col-4 col-form-label text-right">
                        FLIDS risk band:
                      </label>
                      <div className="col-8 p-0">
                        <select
                          onChange={(e) => changeHandler(e, "flidsRisk", false)}
                          className="form-control"
                          id="exampleSelect1"
                          value={submissionForm.flidsRisk}>
                          <option></option>
                          <option id="Yellow">Yellow</option>
                          <option id="Orange">Orange</option>
                          <option id="Red">Red</option>
                        </select>
                      </div>
                    </div>
                    <div className="form-group row">
                      <label
                        htmlFor="exampleSelect1"
                        className="col-4 col-form-label text-right">
                        FLIDS assessment outcome:
                      </label>
                      <div className="col-8 p-0">
                        <select
                          onChange={(e) => changeHandler(e, "flidsOutcome")}
                          className="form-control"
                          id="exampleSelect1"
                          value={submissionForm.flidsOutcome}>
                          <option></option>
                          <option id="Zone 0">Zone 0</option>
                          <option id="Zone 1">Zone 1</option>
                          <option id="Zone 2">Zone 2</option>
                          <option id="Zone 2">Zone 2 - NE</option>
                          <option id="Unzoned">Unzoned</option>
                        </select>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-4">
                        <label></label>
                      </div>
                      <div className="col-8">
                        <small>
                          All new and existing zones to be recorded.
                        </small>
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-4 col-form-label text-right">
                        DSEAR zones
                      </label>

                      <div className="col-8 p-0">
                        <Select
                          onChange={(e) => dsearChangeHandler(e, "dsearZone")}
                          isMulti
                          value={submissionForm.dsearZone.map((dsear) => {
                            return { label: dsear.zone, value: dsear.zone };
                          })}
                          options={dsearZones}
                          id="exampleSelect2"></Select>
                      </div>
                    </div>

                    <table className="table">
                      <thead>
                        <tr>
                          <th>Zone</th>
                          <th>Rating</th>
                        </tr>
                      </thead>
                      <tbody>
                        {submissionForm?.dsearZone?.map((zone) => {
                          return (
                            <tr>
                              <td>{zone.zone}</td>
                              <td>
                                <div className="form-group row">
                                  <div className="col-8 p-0">
                                    <select
                                      onChange={(e) =>
                                        dsearTableChangeHandler(
                                          e,
                                          "dsearZone",
                                          zone.zone
                                        )
                                      }
                                      className="form-control"
                                      id="exampleSelect1"
                                      value={zone.rating}>
                                      <option></option>
                                      <option id="Zone 0">Zone 0</option>
                                      <option id="Zone 1">Zone 1</option>
                                      <option id="Zone 2">Zone 2</option>
                                      <option id="Zone 2">Zone 2 - NE</option>
                                      <option id="Unzoned">Unzoned</option>
                                    </select>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    <div className="form-group row">
                      <label
                        htmlFor="exampleSelect1"
                        className="col-4 col-form-label text-right">
                        Are you aware of all the existing DSEAR zones impacted
                        on this site?
                      </label>
                      <div className="col-8 p-0">
                        <select
                          onChange={(e) => changeHandler(e, "dsearIden")}
                          className="form-control"
                          value={submissionForm.dsearIden}
                          id="exampleSelect1">
                          <option id="YES">YES</option>
                          <option id="NO">NO</option>
                        </select>
                      </div>
                    </div>
                    <div className="form-group row">
                      <label
                        htmlFor="exampleSelect1"
                        className="col-4 col-form-label text-right">
                        Are you confident you understand the implications to
                        design for new and existing DSEAR zones?
                      </label>
                      <div className="col-8 p-0">
                        <select
                          onChange={(e) => changeHandler(e, "dsearImp")}
                          defaultValue="NO"
                          className="form-control"
                          id="exampleSelect1"
                          value={submissionForm.dsearImp}>
                          <option id="YES">YES</option>
                          <option id="NO">NO</option>
                        </select>
                      </div>
                    </div>
                    <div className="form-group row">
                      <label
                        htmlFor="exampleSelect1"
                        className="col-4 col-form-label text-right">
                        Have you specified the DSEAR requirements for
                        sub-contractors?
                      </label>
                      <div className="col-8 p-0">
                        <select
                          onChange={(e) => changeHandler(e, "dsearSpec")}
                          defaultValue="NO"
                          className="form-control"
                          id="exampleSelect1"
                          value={submissionForm.dsearSpec}>
                          <option id="YES">YES</option>
                          <option id="NO">NO</option>
                        </select>
                      </div>
                    </div>
                    <div className="form-group row">
                      <label
                        htmlFor="exampleSelect1"
                        className="col-4 col-form-label text-right">
                        Are the MEICA designers approved for DSEAR/ATEX design
                        on the competency register?
                      </label>
                      <div className="col-8 p-0">
                        <select
                          onChange={(e) => changeHandler(e, "dsearApp")}
                          defaultValue="NO"
                          className="form-control"
                          id="exampleSelect1"
                          value={submissionForm.dsearApp}>
                          <option id="YES">YES</option>
                          <option id="NO">NO</option>
                        </select>
                      </div>
                    </div>
                    <p
                      style={{
                        fontWeight: "bold",
                        backgroundColor:
                          submissionForm.tmRag === "AMBER"
                            ? "#f5b642"
                            : submissionForm.tmRag === "GREEN"
                            ? "#66f542"
                            : "#f54242",
                      }}>
                      RAG STATUS - {submissionForm.tmRag}
                    </p>
                  </div>
                  <br />
                  <div style={{ textAlign: "center" }}>
                    {/* <button
                    type="button"
                    className="btn btn-primary col-3"
                    //onClick={handleSubmit}
                  >
                    Submit
                  </button> */}

                    <button
                      type="button"
                      className="btn btn-success col-3"
                      onClick={save}>
                      {editDsear != true ? "Save & Add To Register" : "Update"}
                    </button>
                  </div>
                </div>
              </div>
            )}
        </div>
      </Div100vh>
    </div>
  );
};

export default DSEARRegister;
